import {
  Box,
  ButtonBase,
  Grid,
  Typography,
} from "@material-ui/core";
import Carousel from "react-material-ui-carousel";
import useStyles from "./ProjectDetails.styles";

function ProjectDetails({ project }: any) {
  const classes = useStyles();

  return (
    <Grid>
      <Box className={classes.carouselBg}>
        <Carousel indicators={false}>
          {(project?.images || []).map((productImages: any) => (
            <Box className={classes.projectImgBox}>
              <img
                src={productImages?.imgUrl}
                className={classes.projectImag}
                alt=""
              />
            </Box>
          ))}
        </Carousel>
      </Box>
      <Box className={classes.detailBody}>
        <Box style={{ marginTop: 15 }}>
          <Typography className={classes.projectTitle}>
            {project?.name}
          </Typography>
          <Box className={classes.technologiesWrapper}>
            {(project?.technologies || []).map(
              (technology: string, index: number) => (
                <ButtonBase className={classes.technology} key={index}>
                  {technology}
                </ButtonBase>
              )
            )}
          </Box>
        </Box>
        <Box className={classes.lineDivider} />
        <Box className={classes.projectDescription}>{project?.description}</Box>
      </Box>
      <Box className={classes.actionBtn}>
        {project?.repo ? (
          <ButtonBase
            onClick={() => window.open(project?.repo, "_blank")}
            className="github"
          >
            Git Repo
          </ButtonBase>
        ) :  <ButtonBase
            className="github"
          >
            Private Repo
          </ButtonBase>}
        {project?.url && (
          <ButtonBase
            onClick={() => window.open(project?.url, "_blank")}
            className="website"
          >
            View Site
          </ButtonBase>
        )}
      </Box>
    </Grid>
  );
}

export default ProjectDetails;
